module.exports = __webpack_public_path__ + "static/media/import-dropdown-not-show-arrow.c85723fb.svg";